// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { AuthContext } from "../App";
// import "./HomePage.css";

// const HomePage = () => {
//   const { currentUser, logout } = useContext(AuthContext);
//    const handlePlay = () => {
//     const video = document.getElementById("custom-video");
//     const btn = document.querySelector(".custom-play-btn");

//     if (video) {
//       video.play();
//       video.setAttribute("controls", true); // Show default controls
//       btn.style.display = "none"; // Hide custom button
//     }
//   };

//   // Lotto 6aus49 draw info (Wednesday or Saturday)
//   const getLottoDrawInfo = () => {
//     const today = new Date();
//     const day = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

//     if (day >= 1 && day <= 3) {
//       return "Wednesday, 6:00 PM";
//     } else {
//       return "Saturday, 8:00 PM";
//     }
//   };

//   // Euro Jackpot draw info (Friday or Tuesday)
//   const getEuroDrawInfo = () => {
//     const today = new Date();
//     const day = today.getDay();

//     if (day === 3 || day === 4 || day === 5) {
//       return "Friday, 6:00 PM";
//     } else {
//       return "Tuesday, 8:00 PM";
//     }
//   };

//   const drawInfoLotto = getLottoDrawInfo();
//   const drawInfoEuro = getEuroDrawInfo();

//   return (
//     <div className="page">
//       {/* Header */}
//       <header className="header">
//         <div className="header-left">
//           <img src="/easy-play-logo.png" alt="LOTTO Logo" className="logo" />
//         </div>
//         <div className="header-center">
//           <span className="brand-centered"></span>
//         </div>
//         <div className="header-right">
//           <div className="auth-links">
//             {currentUser ? (
//               <button onClick={logout} className="auth-link logout-button">
//                 Logout
//               </button>
//             ) : (
//               <>
//                 <Link to="/login" className="auth-link">Login</Link>
//                 <Link to="/register" className="auth-link">Register</Link>
//               </>
//             )}
//           </div>
//         </div>
//       </header>

//       <section className="hero">
//   <img
//     src="/Easy Play banner sep1.jpg"
//     alt="Hero Banner Desktop"
//     className="hero-img desktop"
//     loading="lazy"
//   />
//   <img
//     src="/Easy Play Mobile sep1.jpg"
//     alt="Hero Banner Mobile"
//     className="hero-img mobile"
//     loading="lazy"
//   />
// </section>


//       {/* Video Banner Section */}
//      <section className="video-banner">
//   <div className="video-wrapper">
//     <h2 className="video-heading">How Easy Play Works</h2>
//     <div className="video-container">
//       <video
//         id="custom-video"
//         className="banner-video"
//         muted
//         playsInline
//         preload="metadata"
//       >
//         <source src="/Easy Play.mp4" type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//       <button className="custom-play-btn" onClick={handlePlay}>
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="40"
//     height="40"
//     viewBox="0 0 24 24"
//     fill="white"
//   >
//     <path d="M8 5v14l11-7z" />
//   </svg>
// </button>

//     </div>
//   </div>
// </section>




//       {/* Hero Description */}
//       <section className="hero-description">
//         <div className="wrapper">
//           <h2 className="hero-heading">Your Easy Way to Millions</h2>
//           <p>
//             <strong>Easy Play 1</strong> is your gateway to winning big with Lotto 6 aus 49 and EuroJackpot.
//             By simply registering, you gain access to weekly opportunities to win millions.
//             Whether you're a seasoned player or just feeling lucky, Easy Play 1 makes lottery participation quick,
//             easy, and exciting.
//           </p>
//           {!currentUser && (
//             <Link to="/register" className="join-now-btn">
//               Join Now
//             </Link>
//           )}
//         </div>
//       </section>

//       {/* Game Cards */}
//       <div className="wrapper">
//         <main className="main">
//           {/* Lotto 6aus49 Card */}
//           <div className="game-card">
//             <div className="card-left stacked">
//               <img src="/lotto1.png" alt="Lotto 6aus49" className="game-logo" />
//               <div className="lotto-results">
//                 {[1, 7, 17, 22, 25, 47].map((num) => (
//                   <span key={num} className="lotto-ball">{num}</span>
//                 ))}
//                 <span className="lotto-ball superzahl">5</span>
//               </div>
//               <div className="alarm-info">
//                 <img src="/alarm.png" alt="Alarm Icon" className="alarm-icon" />
//                 <span>{drawInfoLotto}</span>
//               </div>
//             </div>
//             <div className="card-right yellow">
//               <div className="jackpot-label">Jackpot</div>
//               <div className="jackpot-amount">1 million. €</div>
//               <div className="chance-text">Chance: 1 in 139 million</div>
//             </div>
//           </div>

//           {/* Euro Jackpot Card */}
//           <div className="game-card">
//             <div className="card-left stacked">
//               <img src="/jackport.png" alt="Euro Jackpot" className="game-logo" />
//               <div className="lotto-results">
//                 {[4, 25, 39, 44, 47].map((num) => (
//                   <span key={`${num}-2`} className="lotto-ball">{num}</span>
//                 ))}
//                 <span className="lotto-ball superzahl">5</span>
//                 <span className="lotto-ball superzahl">10</span>
//               </div>
//               <div className="alarm-info">
//                 <img src="/alarm.png" alt="Alarm Icon" className="alarm-icon" />
//                 <span>{drawInfoEuro}</span>
//               </div>
//             </div>
//             <div className="card-right blue">
//               <div className="jackpot-label">Euro Jackpot</div>
//               <div className="jackpot-amount">10 million. €</div>
//               <div className="chance-text">Chance: 1 in 139 million</div>
//             </div>
//           </div>
//         </main>
//       </div>
//       {/* Footer */}
// <footer class="footer">
//   <div class="wrapper">
//     <div class="footer-content centered">
//       <p>&copy; 2025 Easy Play. All rights reserved.</p>
//     </div>
//   </div>
// </footer>



import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../App";
import "./HomePage.css";

const HomePage = () => {
  const { currentUser, logout } = useContext(AuthContext);

  /* ---------------------------------------
     Chat Widget Integration (React-safe)
  --------------------------------------- */
  useEffect(() => {
    // 1️⃣ Widget config
    window.__CHATWIDGET_CONFIG__ = {
      API_BASE: "https://api.texef.com",
      TENANT_ID: "tenant_738abcf4",
      BOT_NAME: "Chinnu",
      LOGO_URL:
        "https://chatbot-amzs3.s3.ap-southeast-2.amazonaws.com/chatbot-user-logo/tenant_738abcf4/logo.png",
    };

    // 2️⃣ Chat root
    if (!document.getElementById("chat-root")) {
      const root = document.createElement("div");
      root.id = "chat-root";
      root.setAttribute("data-chat-widget", "");
      document.body.appendChild(root);
    }

    // 3️⃣ Widget CSS
    if (!document.getElementById("chat-widget-style")) {
      const link = document.createElement("link");
      link.id = "chat-widget-style";
      link.rel = "stylesheet";
      link.href = "https://pop-up-version-a.vercel.app/style.css";
      document.head.appendChild(link);
    }

    // 4️⃣ Widget SDK
    if (!window.ChatWidget) {
      const script = document.createElement("script");
      script.src =
        "https://pop-up-version-a.vercel.app/chat-widget-sdk.iife.js";
      script.async = true;

      script.onload = () => {
        if (window.ChatWidget?.initChatWidget) {
          window.ChatWidget.initChatWidget({
            apiBase: window.__CHATWIDGET_CONFIG__.API_BASE,
            containerId: "chat-root",
            enableWebSocket: true,
            botName: window.__CHATWIDGET_CONFIG__.BOT_NAME,
            botLogo: window.__CHATWIDGET_CONFIG__.LOGO_URL,
          });
        }
      };

      document.body.appendChild(script);
    }
  }, []);

  /* ---------------------------------------
     Video play handler
  --------------------------------------- */
  const handlePlay = () => {
    const video = document.getElementById("custom-video");
    const btn = document.querySelector(".custom-play-btn");

    if (video) {
      video.play();
      video.setAttribute("controls", true);
      if (btn) btn.style.display = "none";
    }
  };

  /* ---------------------------------------
     Draw info helpers
  --------------------------------------- */
  const getLottoDrawInfo = () => {
    const day = new Date().getDay();
    return day >= 1 && day <= 3
      ? "Wednesday, 6:00 PM"
      : "Saturday, 8:00 PM";
  };

  const getEuroDrawInfo = () => {
    const day = new Date().getDay();
    return day === 3 || day === 4 || day === 5
      ? "Friday, 6:00 PM"
      : "Tuesday, 8:00 PM";
  };

  return (
    <div className="page">
      {/* ---------- HEADER ---------- */}
      <header className="header">
        <div className="header-left">
          <img
            src="/easy-play-logo.png"
            alt="Easy Play Logo"
            className="logo"
          />
        </div>

        <div className="header-right">
          {currentUser ? (
            <button onClick={logout} className="auth-link logout-button">
              Logout
            </button>
          ) : (
            <>
              <Link to="/login" className="auth-link">
                Login
              </Link>
              <Link to="/register" className="auth-link">
                Register
              </Link>
            </>
          )}
        </div>
      </header>

      {/* ---------- HERO ---------- */}
      <section className="hero">
        <img
          src="/Easy Play banner sep1.jpg"
          alt="Hero Desktop"
          className="hero-img desktop"
        />
        <img
          src="/Easy Play Mobile sep1.jpg"
          alt="Hero Mobile"
          className="hero-img mobile"
        />
      </section>

      {/* ---------- VIDEO ---------- */}
      <section className="video-banner">
        <h2 className="video-heading">How Easy Play Works</h2>
        <div className="video-container">
          <video
            id="custom-video"
            className="banner-video"
            muted
            playsInline
            preload="metadata"
          >
            <source src="/Easy Play.mp4" type="video/mp4" />
          </video>

          <button className="custom-play-btn" onClick={handlePlay}>
            ▶
          </button>
        </div>
      </section>

      {/* ---------- DESCRIPTION ---------- */}
      <section className="hero-description">
        <h2>Your Easy Way to Millions</h2>
        <p>
          <strong>Easy Play 1</strong> lets you participate in Lotto 6 aus 49
          and EuroJackpot with ease.
        </p>
        {!currentUser && (
          <Link to="/register" className="join-now-btn">
            Join Now
          </Link>
        )}
      </section>

      {/* ---------- GAME CARDS ---------- */}
      <main className="main">
        <div className="game-card">
          <div className="card-left">
            <img src="/lotto1.png" alt="Lotto" />
            <span>{getLottoDrawInfo()}</span>
          </div>
          <div className="card-right yellow">
            <div className="jackpot-amount">1 Million €</div>
          </div>
        </div>

        <div className="game-card">
          <div className="card-left">
            <img src="/jackport.png" alt="Euro Jackpot" />
            <span>{getEuroDrawInfo()}</span>
          </div>
          <div className="card-right blue">
            <div className="jackpot-amount">10 Million €</div>
          </div>
        </div>
      </main>

      {/* ---------- FOOTER ---------- */}
      <footer className="footer">
        <p>© 2025 Easy Play. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;

//     </div>
//   );
// };

// export default HomePage;
